<h1 mat-dialog-title style="color: rgb(41, 5, 204);">Reason</h1>
<div mat-dialog-content>
  <p>Please select a reason to clear the issue <b class="text-danger">{{data.msg}}</b></p>
  <mat-form-field class="col-md-10 col-sm-12">
    <mat-label>Select Reason</mat-label>
    <mat-select [(value)]="selectedReason">
      <mat-option *ngFor="let reason of reasons" [value]="reason.reason">{{reason.reason}}</mat-option>
      <mat-option value="other">Other</mat-option>
    </mat-select>
  </mat-form-field>
  <br *ngIf="selectedReason === 'other'">
  <mat-form-field *ngIf="selectedReason === 'other'" class="col-md-10 col-sm-12">
    <mat-label>Please specify the reason.</mat-label>
    <textarea matInput [(ngModel)]="otherBox"></textarea>
  </mat-form-field>
</div>
<div mat-dialog-actions>
	<div class="col-lg-12 text-right mb-2 mt-2">
		<button type="button" mat-raised-button [mat-dialog-close]="data.animal" cdkFocusInitial>
			Cancel
		</button>&nbsp;
		<button type="button" [disabled]="!selectedReason || (selectedReason === 'other' && (!otherBox || (otherBox.trim().length === 0)))" mat-raised-button
			color="primary" (click)="onOk()">
			Proceed
		</button>
	</div>
</div>
